import * as React from 'react'
import Skeleton from '@mui/material/Skeleton'
import { Grid } from '@mui/material'

const CommunityPageHeaderLoading = ({ loading }) => loading
  ? (
    <>
      <LoadingBanner/>
      <LoadingCommunityHeader/>
    </>
    )
  : <></>

const LoadingBanner = () => (
  <Skeleton variant="rectangular" height={130} animation="wave" />
)

const LoadingCommunityHeader = () => (
  <Grid container>
    <Grid item xs={1}>
      <Skeleton variant="circular" sx={{ width: 75, height: 75, marginTop: '-2rem', marginLeft: '1.2rem', border: '4px solid darkgray' }} animation="wave" />
    </Grid>
    <Grid item xs={5}>
      <Skeleton variant="text" width="80%" sx={{ marginTop: '0.7rem', marginLeft: '2rem', fontSize: '30px' }}/>
    </Grid>
    <Grid item xs={1}></Grid>
    <Grid item xs={5}>
      <Skeleton variant="text" width="85%" sx={{ marginTop: '0.5rem', marginLeft: '0.5rem', fontSize: '30px' }}/>
    </Grid>
    <Grid item xs={12} sx={{ marginTop: '-0.1rem', marginLeft: '2rem', paddingBottom: '0.25rem' }}>
      <Skeleton variant="text" width="60%"/>
    </Grid>
  </Grid>
)

export default CommunityPageHeaderLoading
